<div class="new-password-container p-6">
    <div class="header">
        <h4 class="lighter-text">{{metaData.labels[0]}}</h4>
        <img mat-dialog-close class="icon-m" src="assets/close-dialog.svg" (click)="close_click()">
    </div>
    <div class="body-wrapper" [formGroup]="pwd">
        <p class="mandatory-field m-0 content-s alert-text">* mandatory</p>
        <div class="body-row-1">
            <div class="body-row-1-left">
                <label class="content-m primary-text">
                    {{metaData.labels[1]}} <span class="alert-text">*</span>
                </label>
                <div class="alert-danger">
                </div>
            </div>
            
            <div class="body-row-1-col-2">
                <div class="input-box-type">
                    <input formControlName="newpassword" [type]="showPass1?'text':'password'" [placeholder]="inputPlaceholders[0]">
                </div>
                <div class="alert-danger">
                    <div class="alert-text content-s" *ngIf="(newPwd.touched||errorMessage) && newPwd.invalid">{{ validationData.password.errors |oneError:newPwd.errors}}</div>
                </div>
            </div>
            <div class="body-row-1-col-3 pb-3">
                <img class="preview-hide-1 icon-s" src="assets/preview_hide.svg" (click)="showPass1 =! showPass1"
                    *ngIf="!showPass1">
                <img class="preview-1 icon-s" src="assets/preview.svg" (click)="showPass1 =! showPass1" *ngIf="showPass1">
            </div>
        </div>
        <div class="body-row-2">
            <div class="body-row-2-left">
                <!-- <label class="content-m primary-text">
                    {{metaData.labels[2]}}<span class="alert-text">*</span>
                </label> -->
                <label class="content-m primary-text">
                    Re-enter new password<span class="alert-text">*</span>
                </label>
                <div class="alert-danger">
                </div>
            </div>
            
            <div class="body-row-2-col-2">
                <div class="input-box-type">
                    <input formControlName="reenterpassword" [type]="showPass2?'text':'password'" [placeholder]="inputPlaceholders[1]">
                </div>
                <div class="alert-danger">
                    <div class="alert-text" *ngIf="(reEnterPwd.touched||errorMessage) &&reEnterPwd.invalid">{{validationData.password.errors |oneError:reEnterPwd.errors}}</div>
                    <div class="alert-text" *ngIf="(reEnterPwd.touched||errorMessage) && reEnterPwd.invalid && reEnterPwd.errors.confirmedValidator">
                        {{validationData.password.errors.pwdnotmatch}}</div>
                </div>
            </div>
            <div class="body-row-2-col-3 pb-3">
                <img class="preview-hide-2 icon-s" src="assets/preview_hide.svg" (click)="showPass2 =! showPass2"
                    *ngIf="!showPass2">
                <img class="preview-2 icon-s" src="assets/preview.svg" (click)="showPass2 =! showPass2" *ngIf="showPass2">
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="footer-buttons">
            <button class="cancel" mat-dialog-close (click)="cancel_click()">{{commonData.buttonLabels.cancel}}</button>
            <button class="submit" (click)="submit_click()">{{commonData.buttonLabels.submit}}</button>
        </div>
    </div>
</div>

<ng-container *ngIf="resetPasswordSpinner">
    <div class="reset-spinner">
        <mat-spinner class="spinner" diameter=20></mat-spinner>
    </div>
</ng-container>